export const servicesPageStyles = {
  container: {
    paddingTop: 'var(--mantine-spacing-xl)',
    paddingBottom: 'var(--mantine-spacing-xl)',
  },
  serviceCard: {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    justifyContent: 'center',
    gap: 'var(--mantine-spacing-md)',
    border: '2px solid #002f2f',
    outline: '5px solid #002f2f',
    outlineOffset: '2px',
    borderRadius: '10px',
    padding: 'var(--mantine-spacing-md)',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    
  },
  serviceImage: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'cover',
  },
}